/* eslint-disable react/jsx-handler-names */
import { find, get, reduce } from "lodash";
import { MDBAlert, MDBInput, MDBSpinner } from "mdbreact";
import React, { Component, Fragment } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import {
  resetAlertSubmitFail,
  submitPayment
} from "~/actions/umc/submitPayment";
import Alert from "~/components/common/atoms/Alert";
import Modal from "~/components/common/molecules/Modal";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import {
  getAllPaymentMethod,
  hideModalPaymentMethod,
  resetPaymentMethod,
  selectedPaymentMethod,
  togglePaymentMethod
} from "~/store/payment/paymentAction";
import {
  bookingShareToPay,
  getBookingTree,
  repaymentBooking,
  reserveBooking
} from "~/store/totalData/actions";
import { routerByPartnerId } from "~/utils/func";
import styles from "./style.module.scss";
import { createForm, createFormField } from "rc-form";
import { openToast } from "~/components/common/molecules/ToastNotification";
import validator from "validator/lib/isEmail";
import cx from "classnames";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentMethodPageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/PaymentHelpsMethod"),
  loading: LoadableLoading
});

class DetectPaymentMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowAlert: false,
      isShowPaymentConfirm: false,
      loadingSubmitBooking: false,
      updateVisa: {
        status: false,
        initValue: {}
      },
      isCheckedVisa: false,
      visaEntered: {
        status: false,
        info: {
          fullName: "",
          userName: "",
          email: ""
        }
      }
    };
  }

  methods = {
    calculate: () => {
      const { schedulesSelected, selectedMethod } = this.props;
      // summary để dùng tính tổng tiền cho nhiều chuyên khoa (umc)
      const total = reduce(
        schedulesSelected,
        (sum, item) => {
          const price = Number(item.service.price);
          return sum + price;
        },
        0
      );
      const medpro = selectedMethod.medproFee
        ? Number(selectedMethod.medproFee)
        : 0;
      const fee = selectedMethod.rate ? Number(selectedMethod.rate) : 0;
      const feeMore = selectedMethod.constRate
        ? Number(selectedMethod.constRate)
        : 0;
      const phi = parseInt((total + medpro) * fee + feeMore);
      const phiThanhToan = phi;
      const phiThanhToanGiaoDich = phiThanhToan || 0;
      const totalPhi = medpro + phiThanhToanGiaoDich;
      return {
        total,
        totalPhi
      };
    },
    toggleAlertFail: () => {
      this.props.OnResetErrorMessgeSubmitPayment();
      this.setState(state => ({
        loadingSubmitBooking: false
      }));
    },
    handleDoPayment: () => {
      const { isRepayment } = this.props;
      const { visaEntered } = this.state;
      if (isRepayment) {
        this.props.repaymentBooking("shareToPay", {
          fullname: visaEntered.info.fullName,
          username: visaEntered.info.userName,
          email: visaEntered.info.email
        });
      } else {
        this.props.reserveBooking();
      }
      this.setState(state => ({
        isShowPaymentConfirm: false
      }));
    },

    toggleShowPaymentConfirm: () => {
      this.setState(state => ({
        isShowPaymentConfirm: !state.isShowPaymentConfirm
      }));
    },

    handleSelectedMethod: (method, methodId) => {
      if (method.checkEmail && !this.state.visaEntered.status) {
        this.methods.toogleModalVisa();
      } else {
        this.props.selectedPaymentMethod(method, methodId);
      }
    },
    toggleAlert: () => {
      this.setState({
        isShowAlert: !this.state.isShowAlert
      });
    },
    handleGoBack: () => {
      const { partnerId } = this.props;
      const route = routerByPartnerId("/xac-nhan-thong-tin", partnerId);
      this.props.history.push(route);
    },
    handleUpdateInfoUser: () => {
      this.props.form.validateFields((error, value) => {
        const { fullName, userName, email } = value;
        if (!error) {
          openToast("Cập nhật thông tin thành công");
          this.methods.toogleModalVisa();
          this.setState({
            visaEntered: {
              status: true,
              info: {
                fullName,
                userName,
                email
              }
            }
          });
        }
      });
    },

    toogleModalVisa: () => {
      const { updateVisa, visaEntered } = this.state;
      console.log("visaEntered.status", visaEntered.status, updateVisa.status);
      if (!visaEntered.status) {
        this.setState(preState => ({
          updateVisa: { ...preState, status: !updateVisa.status }
        }));
      }
    }
  };

  styles = {
    loading: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },

    loading_submit_booking: {
      position: "fixed",
      top: 0,

      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: "black",
      opacity: 0.5
    },

    body_modal: {
      fontSize: "1rem"
    },
    body_modal_image: {
      margin: "auto",
      display: "block",
      objectFit: "cover",
      marginBottom: "10px",
      maxHeight: "100px"
    }
  };

  renderBodyModalConfirmPayment = () => {
    const { selectedMethod } = this.props;
    const selectedMethodName =
      Object.keys(selectedMethod).length > 0
        ? selectedMethod.name
        : "Chọn phương thức thanh toán";

    const price = get(selectedMethod, "grandTotal", 0);
    const selectedMethodImage = get(selectedMethod, "paymentIcon.path", "");

    if (selectedMethod.bankAccount) {
      const accountHolder = get(
        selectedMethod,
        "bankAccount.accountHolder",
        ""
      );
      const accountNumber = get(
        selectedMethod,
        "bankAccount.accountNumber",
        ""
      );
      const bankBranch = get(selectedMethod, "bankAccount.bankBranch", "");
      return (
        <Fragment>
          <div style={this.styles.body_modal}>
            {selectedMethodImage && (
              <img
                style={this.styles.body_modal_image}
                src={selectedMethodImage}
                alt={selectedMethodName}
              />
            )}
            <MDBAlert color="primary">
              <p>Thông tin chuyển khoản:</p>
              Tài khoản: <strong>{accountHolder}</strong> <br />
              Số tài khoản: <strong>{accountNumber}</strong> <br />
              Chi nhánh: <strong>{bankBranch}</strong> <br />
              Số tiền: <strong>{Number(price).toLocaleString("vi-VN")}đ</strong>
            </MDBAlert>
          </div>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <div style={this.styles.body_modal}>
          {selectedMethodImage && (
            <img
              style={this.styles.body_modal_image}
              src={selectedMethodImage}
              alt={selectedMethodName}
            />
          )}
          <p>
            Thanh toán số tiền{" "}
            <strong>{Number(price).toLocaleString("vi-VN")}đ</strong> bằng{" "}
            {selectedMethodName}
          </p>
          <MDBAlert color="primary">
            Bạn sẽ nhận được phiếu khám bệnh ngay khi{" "}
            <strong>thanh toán thành công</strong>. Trường hợp không nhận được
            phiếu khám bệnh, vui lòng liên hệ <strong>19002115</strong>.
          </MDBAlert>
        </div>
      </Fragment>
    );
  };

  renderBodyVisaUmc = () => {
    const {
      form: { getFieldProps, getFieldsError }
    } = this.props;
    const {
      fullName: fullNameError,
      userName: userNameError,
      email: emailError
    } = getFieldsError();
    return (
      <div>
        <p className={styles.description}>
          Theo quy định của Tổ chức thẻ Quốc tế, vui lòng điền đầy đủ thông tin
          người thanh toán
        </p>
        <div className={styles.form_column}>
          <form
            className={cx(styles.form_contact_info, styles.form_contact_custom)}
          >
            <div className={styles.form_group}>
              <label htmlFor="label_name">
                Họ & tên<sup>*</sup>
              </label>
              <input
                {...getFieldProps("fullName", {
                  rules: [
                    {
                      required: true,
                      message: "Vui lòng nhập họ và tên"
                    }
                  ]
                })}
                id="label_name"
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập họ và tên"
              />
              <span className={styles.input_warning}>{fullNameError}</span>
            </div>

            <div className={styles.form_group}>
              <label htmlFor="label_mobile">
                Số điện thoại<sup>*</sup>
              </label>
              <input
                {...getFieldProps("userName", {
                  rules: [
                    {
                      validator: this.validatePhone
                    }
                  ]
                })}
                id="label_mobile"
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập số điện thoại"
              />
              <span className={styles.input_warning}>{userNameError}</span>
            </div>

            <div className={styles.form_group}>
              <label htmlFor="label_email">
                Email<sup>*</sup>
              </label>
              <input
                {...getFieldProps("email", {
                  rules: [{ validator: this.validatorEmail }]
                })}
                id="label_email"
                type="text"
                className="form-control"
                placeholder="Vui lòng nhập email"
              />
              <span className={styles.input_warning}>{emailError}</span>
            </div>

            <div className={styles.form_group}>
              <MDBInput
                {...getFieldProps("confirm")}
                label="Tôi xác nhận thông tin trên là chính xác và hoàn toàn chịu
                    trách nhiệm về thông tin này."
                type="checkbox"
                id="confirm"
                className={styles.input}
                onChange={e => {
                  this.setState({ isCheckedVisa: e.target.checked });
                }}
              />
            </div>
          </form>
        </div>
      </div>
    );
  };

  componentDidMount() {
    const { resetPaymentMethod, hideModalPaymentMethod } = this.props;

    resetPaymentMethod();
    hideModalPaymentMethod();
    const {
      match: {
        params: { code }
      }
    } = this.props;
    this.props.bookingShareToPay(code);
  }

  componentWillUnmount() {
    this.props.OnResetErrorMessgeSubmitPayment();
  }

  validatePhone = (rule, value, callback) => {
    if (value) {
      const patternMobile = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
      if (patternMobile.test(value)) {
        callback();
      } else {
        const patternPhone = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
        if (patternPhone.test(value)) {
          callback();
        } else callback("Vui lòng nhập đúng định dạng!");
      }
    } else {
      callback("Vui lòng nhập số điện thoại!");
    }
  };

  validatorEmail = (rule, value, callback) => {
    if (!value) {
      callback("Vui lòng nhập email!");
    } else {
      if (!validator.isEmail(value.trim())) {
        callback("Vui lòng nhập đúng định dạng email !");
      } else callback();
    }
  };

  handleCancel = () => {
    this.setState({ isCheckedVisa: false });
    this.methods.toogleModalVisa();
  };

  render() {
    const { errorMsg, errorBooking, loading } = this.props;

    const {
      // selectedMethod,
      isShowAlert,
      isShowPaymentConfirm,
      loadingSubmitBooking,
      updateVisa,
      isCheckedVisa
    } = this.state;

    // const objCheckNextStep = Object.create(null);
    // if (Object.keys(selectedMethod).length > 1) {
    //   objCheckNextStep.nextStep = true;
    // }

    const errorMessage =
      errorBooking.error_code === 1011
        ? `Chuyên khoa ${errorBooking.booking_info.subject.name}
        đã hết số khung giờ này. Vui lòng chọn lại khung giờ khác!`
        : errorBooking.error_code;

    if (loading) {
      return (
        <div className={styles.loading_spinner}>
          <div className={styles.loading}>
            <MDBSpinner big crazy tag="div" />
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <PaymentMethodPageDesktop {...this.props} {...this.methods} />

        {loadingSubmitBooking && !errorMsg && (
          <div style={this.styles.loading_submit_booking}>
            <div style={this.styles.loading}>
              <MDBSpinner big crazy tag="div" />
            </div>
          </div>
        )}

        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={isShowPaymentConfirm}
          title="Xác nhận thanh toán"
          children={this.renderBodyModalConfirmPayment()}
          centered
          footer
          footerConfirm
          className="centered"
          toggle={this.methods.toggleShowPaymentConfirm}
          cancelText="Quay lại"
          okText="Đồng ý"
          onCancel={this.methods.toggleShowPaymentConfirm}
          onOk={this.methods.handleDoPayment}
        />

        <Alert
          isModal={!!errorBooking}
          message={errorMessage || ""}
          toggleAlert={this.methods.toggleAlertFail}
        />
        <Alert
          isModal={isShowAlert}
          message="Vui lòng chọn phương thức thanh toán"
          toggleAlert={this.methods.toggleAlert}
        />

        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={updateVisa.status}
          title="Thông báo"
          centered
          className="centered"
          toggle={this.handleCancel}
          okText="Xác nhận"
          cancelText="Trở lại"
          footer
          footerConfirm
          okDisabled={!isCheckedVisa}
          onCancel={this.handleCancel}
          children={this.renderBodyVisaUmc()}
          onOk={this.methods.handleUpdateInfoUser}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { IsAuthenticated },
    payment: { selectedMethod, data, showModal, price },
    doctorAndTime: { sumaryInfo },
    umcSubmitPayment: {
      isRedirectToPaymentSupportPage,
      errorMsg,
      errorBooking
    },
    features: { selectedFeature, selectedFeatureBooking },
    totalData: {
      schedulesSelected,
      bookingTree,
      loadingReserveBooking,
      loading,
      isRepayment,
      partnerId,
      subject: { isHasSubject },
      service: { isHasService },
      room: { isHasRoom },
      doctor: { isHasDoctor },
      paymentInformation
    },
    hospital: { selectedHospital }
  } = state;
  return {
    IsAuthenticated,
    device: type,
    selectedMethod,
    sumaryInfo,
    isRedirectToPaymentSupportPage,
    errorMsg,
    errorBooking,
    showModal,
    data,
    selectedFeature,
    selectedFeatureBooking,
    schedulesSelected,
    bookingTree,
    loadingReserveBooking,
    price,
    loading,
    isRepayment,
    selectedHospital,
    partnerId,
    isHasSubject,
    isHasService,
    isHasRoom,
    isHasDoctor,
    paymentInformation
  };
};

const mapDispatchToProps = dispatch => ({
  bookingShareToPay: code => {
    dispatch(bookingShareToPay(code));
  },
  OnRequestAllPaymentMethod: () => {
    dispatch(getAllPaymentMethod());
  },
  OnTogglePaymentMethod: () => {
    dispatch(togglePaymentMethod());
  },
  OnSubmitPayment: () => {
    dispatch(submitPayment());
  },
  OnResetErrorMessgeSubmitPayment: () => {
    dispatch(resetAlertSubmitFail());
  },
  selectedPaymentMethod: (method, methodId) => {
    dispatch(selectedPaymentMethod(method, methodId));
  },
  hideModalPaymentMethod: () => {
    dispatch(hideModalPaymentMethod());
  },
  resetPaymentMethod: () => dispatch(resetPaymentMethod()),
  reserveBooking: () => dispatch(reserveBooking()),
  repaymentBooking: (typeRepay, params) =>
    dispatch(repaymentBooking(typeRepay, params)),
  getBookingTree: (text, id) => dispatch(getBookingTree(text, id))
});

const PaymentHelpsMethodHelmet = withTitle({
  component: DetectPaymentMethod,
  title: `${hospitalName.value} | Chọn hình thức thanh toán`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  createForm({
    mapPropsToFields: props => {
      const { UserInfoForm } = props;
      return {
        fullName: createFormField(UserInfoForm?.fullName),
        userName: createFormField(UserInfoForm?.userName),
        email: createFormField(UserInfoForm?.email),
        confirm: createFormField(UserInfoForm?.confirm)
      };
    }
  })(PaymentHelpsMethodHelmet)
);
